<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "LiveKeyWordTimeSlicing",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }, {
        name: 'phone',
        placeholder: '手机号',
        type: 'input'
      }, {
        name: 'liveRoomId',
        placeholder: '直播间ID',
        type: 'input'
      },
      ],
      permission: {
        add: 'keywordTimeSlicing:add',
        update: 'keywordTimeSlicing:update',
        delete: 'keywordTimeSlicing:delete',
        deleteBatch: 'keywordTimeSlicing:deleteBatch'
      },
      url: {
        get: '/keywordTimeSlicing/listByCondition',
        add: '/keywordTimeSlicing/add',
        update: '/keywordTimeSlicing/update',
        delete: '/keywordTimeSlicing/delete/',
        delete_batch: '/keywordTimeSlicing/deleteBatch',
        status: '/keywordTimeSlicing/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      }, {
        field: 'phone',
        label: '用户',
        show: true,
        width: '',
      }, {
        field: 'liveRoomId',
        label: '直播间ID',
        show: true,
        width: '',
      }, {
        field: 'transcriptionUrl',
        label: '时间分片源文件',
        show: true,
        width: '',
      }, {
        field: 'keyword',
        label: '关键词',
        show: true,
        width: '',
      }, {
          field: 'content',
          label: '时间分片内容',
          detail: true,
          show: false,
          width: '',
        }, {
          field: 'taskId',
          label: '任务ID',
          detail: true,
          show: true,
          width: '',
        }, {
        field: 'transcriptions',
        label: '视频剪辑时间分片参数',
        show: false,
        detail: true,
        width: '',
      }, {
        field: 'videoUrl',
        label: '待剪辑的视频文件URL',
        show: true,
        width: '',
      },{
        field: 'outputFormat',
        label: '剪辑后视频输出文件的格式',
        show: true,
        width: '',
      }, {
          field: 'status',
          label: '状态',
          show: {
            type: 'tag',
            tags: [{
              key: 0,
              value: '失败',
              type: 'danger'
            }, {
              key: 1,
              value: '时间分片进行中',
              type: 'warning'
            }, {
              key: 2,
              value: '时间分片已完成',
              type: 'success'
            }]
          },
          detail: false,
          width: '',
        },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        },],
      operate: [],
      formFields: {
        addTitle: '直播',
        updateTitle: '直播',
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules: [{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        }, {
          field: 'phone',
          label: '用户',
          type: 'input',
          placeholder: '手机号',
          rules: [{message: '手机号', trigger: 'blur', required: true}],
          add: true,
          update: true,
        },{
            field: 'language',
            label: '语言',
            type: 'select',
            selectData: [{
              id: 'cn',
              name: '中文'
            }, {
              id: 'en',
              name: '英文'
            }],
            placeholder: '语言',
            rules: [{message: '请输入语言', trigger: 'blur', required: true}],
            add: false,
            update: false,
          }],
      }
    }
  }
}
</script>

<style scoped>

</style>
